import React from 'react'
import { useAuth } from '~/routes/components/AuthProvider'
import { FAT_PROTEIN_SLUG, MILK_FIXED_SLUG, MILK_STOCK_EXCHANGE } from '~/Constants'
import { useTranslation } from 'react-i18next'
import { FixedPricePrefixType } from '~/api/services/dashboard'
import i18n from '~/components/i18n'
import AmountsTable from './AmountsTable'

const getFPTableColumnHeaders = (amountUnit, priceLabel) => [
  {
    name: i18n.t('Trading months'),
    key: 'month',
    type: 'dateRibbon',
    format: 'MMM YYYY'
  },
  {
    name: i18n.t('Max of trading month amount (in {{amountUnit}})', { amountUnit }),
    key: 'amount',
    type: 'number'
  },
  {
    name: i18n.t('Fixed price amount (in {{amountUnit}}) / [in %]', { amountUnit }),
    key: 'amount',
    type: 'confirmed'
  },
  {
    name: i18n.t('Available trading amount (in {{amountUnit}}) / [in %]', { amountUnit }),
    key: 'remainingAmount',
    type: 'available'
  },
  {
    name: i18n.t('Average fixed price {{priceLabel}}', { priceLabel }),
    key: 'avgPrice',
    type: 'no-unit-number'
  },
  {
    name: i18n.t('Actions')
  }
]

const getTableStockEColumnHeaders = (amountUnit, priceLabel) => [
  {
    name: i18n.t('Trading months'),
    key: 'month',
    type: 'dateRibbon',
    format: 'MMM YYYY'
  },
  {
    name: i18n.t('Max of trading month amount (in {{amountUnit}})', { amountUnit }),
    key: 'amount',
    type: 'number'
  },
  {
    name: i18n.t('Hedging amount (in {{amountUnit}}) / [in %]', { amountUnit }),
    key: 'amount',
    type: 'confirmed'
  },
  {
    name: i18n.t('Available trading amount (in {{amountUnit}}) / [in %]', { amountUnit }),
    key: 'remainingAmount',
    type: 'available'
  },
  {
    name: i18n.t('Average BLE price ({{priceLabel}})', { priceLabel }),
    key: 'avgPrice',
    type: 'no-unit-number'
  },
  {
    name: i18n.t('Actions')
  }
]

interface TradingAmounts {
  tableColumnHeaders: any[];
  title: string;
}

const TradingAmounts: React.FC = () => {
  const { t } = useTranslation()
  const { systemData: { modules, amountUnit, amountVolume, amountPrice } } = useAuth()
  const priceFixedLabel = `(${amountPrice == 'e' ? '€' : '€ Ct'}/${amountVolume > 1 ? amountVolume : ''}${amountUnit})`

  const tradingAmount = modules.reduce((prevValue, currentValue) => {
    if (currentValue.slug === MILK_FIXED_SLUG) {
      prevValue[FixedPricePrefixType.FixedPrice] = {
        tableColumnHeaders: getFPTableColumnHeaders(amountUnit, priceFixedLabel),
        title: t('Milk fixed price')
      };
    } else if (currentValue.slug === FAT_PROTEIN_SLUG) {
      prevValue[FixedPricePrefixType.FatProtein] = {
        tableColumnHeaders: getFPTableColumnHeaders(amountUnit, '(€ Ct/kg)'),
        title: t('Fat & protein')
      };
    } else if (currentValue.slug === MILK_STOCK_EXCHANGE) {
      prevValue[FixedPricePrefixType.StockExchange] = {
        tableColumnHeaders: getTableStockEColumnHeaders(amountUnit, priceFixedLabel),
        title: t('Stock exchange')
      };
    }
    return prevValue;
  }, {} as Record<FixedPricePrefixType, TradingAmounts>);

  return <div style={{ display: 'flex', flexDirection: 'column', flexWrap: 'wrap', gap: 20 }}>
    {Object.values(tradingAmount).map((tradingActivitie, index) => {
      const prefix = Object.keys(tradingAmount)[index] as FixedPricePrefixType
      return <AmountsTable
        key={prefix}
        prefix={prefix}
        tableColumnHeaders={tradingActivitie?.tableColumnHeaders || []}
        title={tradingActivitie.title || ''}
      />
    })}
  </div>
}
export default TradingAmounts
